async function createVisor(token, visorId) {
  const url = `${process.env.REACT_APP_API_URL}/Visor/CreateVisor?visorId=${visorId}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  const responseBody = await response.text();

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorResponse = JSON.parse(responseBody);
      errorMessage = errorResponse.message || errorMessage;
    } catch (e) {
      // Failed to parse error response, keep default error message
    }
    throw new Error(errorMessage);
  }

  try {
    return JSON.parse(responseBody);
  } catch (error) {
    throw new Error("Failed to parse response as JSON: " + error.message);
  }
}

export default { createVisor };
